var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"shi-shi-dong-tai"},[_c('PageBlock',{attrs:{"title":"实时动态"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_c('span'),_vm._v(" 今日受理量 ")]),_c('div',{staticClass:"value-content"},_vm._l((_vm.value),function(item,index){return _c('div',{staticClass:"num-item"},[_vm._v(_vm._s(item))])}),0)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }